import axios from "axios";
import { getUserData } from './Storage';

const FIRE_BASE_URL = "https://identitytoolkit.googleapis.com/v1";
const API_KEY = process.env.REACT_APP_FIRE_BASE_API_KEY;
const REGISTER_URL =  FIRE_BASE_URL+`/accounts:signUp?key=${API_KEY}`;
const LOGIN_URL =  FIRE_BASE_URL+`/accounts:signInWithPassword?key=${API_KEY}`;
const USER_DETAILS_URL =  FIRE_BASE_URL+`/accounts:lookup?key=${API_KEY}`;
const CHANGE_PASSWORD_URL = FIRE_BASE_URL+`/accounts:update?key=${API_KEY}`;
const FORGET_PASSWORD_URL = FIRE_BASE_URL+`/accounts:sendOobCode?key=${API_KEY}`;

const M_BASE_URL = process.env.REACT_APP_API_URL;
const M_REGISTER_URL = M_BASE_URL + `/signup`;
const QUICK_START_URL = M_BASE_URL + '/quickstart';
const M_USER_DETAILS_URL = M_BASE_URL + '/userdetails';
const BOOKING_DETAILS_URL = M_BASE_URL + '/bookingdetails';
const UPDATE_PROFILE_URL = M_BASE_URL + '/user/updateprofile';
const ROOM_DETAILS_URL = M_BASE_URL + '/roomdetails/';
const CREATE_BOOKING_URL = M_BASE_URL + '/createbooking';

const NEW_ROOM_URL = M_BASE_URL + '/admin/newroom';
const UPDATE_ROOM_URL = M_BASE_URL + '/admin/updateroom/';
const GET_ROOMS_URL = M_BASE_URL + '/rooms?';
const DELETE_ROOM_URL = M_BASE_URL +'/admin/deleteroom/';
const M_ALL_USER_DETAILS_URL = M_BASE_URL + '/admin/alluserdetails';
const ALL_BOOKING_DETAILS_URL = M_BASE_URL + '/admin/allbookingdetails';
const BOOKING_ID_DETAILS_URL = M_BASE_URL + '/admin/bookingiddetails/';



export const RegisterApi = (inputs) => {
    let data = { email: inputs.email, password: inputs.pwd }
    return axios.post(REGISTER_URL, data)
}
export const M_RegisterApi = (inputs, fireRegister) => {
    let data = { fullName: inputs.fullName, email: inputs.email, pno: inputs.pno, address: inputs.address, localId: fireRegister.data.localId }
    return axios.post(M_REGISTER_URL, data)
}

export const QuickStartApi = () => {
    return axios.post(QUICK_START_URL)
}

export const LoginApi = (inputs) => {
    let data = { email: inputs.email, password: inputs.pwd }
    return axios.post(LOGIN_URL, data)
}

export const UserDetailsApi = () => {
    let data = { idToken: getUserData() }
    return axios.post(USER_DETAILS_URL, data)
}
export const M_UserDetailsApi = (test) => {
    let data = { localId: test }
    return axios.post(M_USER_DETAILS_URL, data)
}

export const M_AllUserDetailsApi = () => {
    return axios.get(M_ALL_USER_DETAILS_URL)
}

export const CreateBookingApi = (data) => {
    return axios.post(CREATE_BOOKING_URL, data)
}

export const BookingDetailsApi = (temp) => {
    let data = { localId: temp}
    return axios.post(BOOKING_DETAILS_URL, data)
}

export const AllBookingDetailsApi = () => {
    return axios.get(ALL_BOOKING_DETAILS_URL)
}


export const ChangePasswordApi = (inputs) => {
    let data = { idToken:inputs.idToken, password:inputs.pwd, returnSecureToken: true }
    return axios.post(CHANGE_PASSWORD_URL, data)
}

export const ForgetPasswordApi = (inputs) => {
    let data = {requestType:"PASSWORD_RESET", email: inputs.email}
    return axios.post(FORGET_PASSWORD_URL, data)
}

export const UpdateProfileApi = (inputs) => {
    let data = { fullName: inputs.fullName, pno: inputs.pno, address: inputs.address, localId: inputs.localId, profile: inputs.profile }
    return axios.put(UPDATE_PROFILE_URL, data)
}

export const RoomDetailsApi =(searchParams) => {
    return axios.get(ROOM_DETAILS_URL+searchParams)
}

export const GetRoomsApi =(searchParams) => {
    return axios.get(GET_ROOMS_URL+searchParams)
}

export const NewRoomApi = (inputs) => {
    let data = { name: inputs.name, price: inputs.price, description: inputs.description, ratings: inputs.ratings, images: [{image: inputs.image1}, {image: inputs.image2}, {image: inputs.image3}, {image: inputs.image4}, {image: inputs.image5}], category: inputs.category, ac : inputs.ac, wifi : inputs.wifi, tv : inputs.tv, heater : inputs.heater, vacancies: inputs.vacancies}
    return axios.post(NEW_ROOM_URL, data)
}

export const UpdateRoomApi = (inputs, id) => {
    let data = { name: inputs.name, price: inputs.price, description: inputs.description, ratings: inputs.ratings, images: [{image: inputs.image1}, {image: inputs.image2}, {image: inputs.image3}, {image: inputs.image4}, {image: inputs.image5}], category: inputs.category, ac : inputs.ac, wifi : inputs.wifi, tv : inputs.tv, heater : inputs.heater, vacancies: inputs.vacancies}
    return axios.put(UPDATE_ROOM_URL+id, data)
}

export const BookingIdDetailsApi =(searchParams) => {
    return axios.get(BOOKING_ID_DETAILS_URL+searchParams)
}

export const DeleteRoomApi =(id)=>{
    return axios.delete(DELETE_ROOM_URL+id)
}